import { render, staticRenderFns } from "./ifp-filter-customers.vue?vue&type=template&id=7f8d022c&"
import script from "./ifp-filter-customers.vue?vue&type=script&lang=ts&"
export * from "./ifp-filter-customers.vue?vue&type=script&lang=ts&"
import style0 from "./ifp-filter-customers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports